import questionAnswerService from "../services/assessment-response.service";
import ACTION_TYPE from "./type.action";
import { setFlowId } from "../../utils/authentication-access";


export const startAssessment = (assessmentid, userId) => async dispatch => {
  await questionAnswerService.start(assessmentid, userId);
  let assessmentreponse = await questionAnswerService.read(assessmentid, userId);
  setFlowId(assessmentreponse.flowId);
  dispatch({
    type: ACTION_TYPE.GET_ASSESSMENTRESPONSE,
    payload: assessmentreponse
  });
};

export const resumeAssessment  = (assessmentid, userId) => async dispatch => {
  await questionAnswerService.resume(assessmentid, userId);
  let assessmentreponse = await questionAnswerService.read(assessmentid, userId);
  setFlowId(assessmentreponse.flowId);
  dispatch({
    type: ACTION_TYPE.GET_ASSESSMENTRESPONSE,
    payload: assessmentreponse
  });
};

export const getAssessmentResponce = (assessmentid, userId) => async dispatch => {
  let assessmentreponse = await questionAnswerService.read(assessmentid, userId);
  setFlowId(assessmentreponse.flowId);
  dispatch({
    type: ACTION_TYPE.GET_ASSESSMENTRESPONSE,
    payload: assessmentreponse
  });
};

export const fetchAssessmentResponces = (classId, studentId) => async dispatch => {
  let assessmentreponses = await questionAnswerService.fetch(classId, studentId);
  dispatch({
    type: ACTION_TYPE.FETCH_ALLASSESSMENTRESPONSES,
    payload: assessmentreponses
  });
};



export const getQuestionResponce = classid => async dispatch => {
dispatch({
    type: ACTION_TYPE.LOADING_QUESTIONRESPONSE,
    payload: true,
  });
  let questionresponse = await questionAnswerService.fetch(classid);
  dispatch({
    type: ACTION_TYPE.GET_QUESTIONRESPONSE,
    payload: questionresponse
  });
};

export const submitAssessment = submitStatus => async dispatch => {
  dispatch({
    type: ACTION_TYPE.ASSESSMENT_SUBMIT,
    payload: submitStatus
  });
};

export const getResult = assessmentResponseId => async dispatch => {
  let resultResponse = await questionAnswerService.result(assessmentResponseId);
  dispatch({
    type: ACTION_TYPE.ASSESSMENT_RESULT,
    payload: resultResponse
  })
}

